module.exports = __webpack_public_path__ + "static/media/flagger.a35f82b9.svg";